import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFileInfoEntryTab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 20,
			r: 20,
			fill: "#E9FEF5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 18V23C30 28 28 30 23 30H17C12 30 10 28 10 23V17C10 12 12 10 17 10H22",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M30 18H26C23 18 22 17 22 14V10L30 18Z",
			stroke: "#2DAB77",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgFileInfoEntryTab;
